/**
 * Phone number validation utility functions
 */

/**
 * Validates phone number according to specific country code rules
 * @param val - The phone number string to validate
 * @returns boolean - true if valid, false if invalid
 */
export const validatePhoneNumber = (val: string): boolean => {
    if (!val || val === "") {
        return true; // Empty is valid (optional field)
    }
    
    // If exactly 3 characters (country code only), it's valid
    if (val.length === 3) {
        return true;
    }
    
    // Define specific country codes that require longer phone numbers
    const specificCountryCodes = ['+40', '+41', '+42', '+43', '+44', '+45', '+46', '+47', '+48', '+49'];
    
    // Check if it starts with one of the specific country codes
    const hasSpecificCountryCode = specificCountryCodes.some(code => val.startsWith(code));
    
    if (hasSpecificCountryCode) {
        // For specific country codes: if length > 3 but <= 12, show error
        if (val.length > 3 && val.length <= 11) {
            return false; // Too short for these countries
        }
        // For specific country codes: must be > 5 characters total
        return val.length > 5;
    } else {
        // For other country codes: allow exactly 4 chars or show error
        return val.length === 4 || val.length >= 11;
    }
}; 